import React, { Component, createRef } from 'react';

class ClipWindow extends Component {
  constructor(props) {
    super(props);

    this.appRef = createRef();
    this.titleRef = createRef();

    this.state = {
      width: 551,
      height: 357,
    };
    
    this.baseWidth = 400;
    this.baseHeight = 225;
    this.bringToFront = this.bringToFront.bind(this);
		this.closeApp = this.closeApp.bind(this);
  }

  componentDidMount() {
    const dragTarget = this.appRef.current;
    const dragHandle = this.titleRef.current;
    const resizeHandle = dragTarget.querySelector('.resize-handle');

    let isDragging = false;
    let isResizing = false;
    let startX, startY, startWidth, startHeight, startLeft, startTop;

    // --- Drag ---
    dragHandle.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.clientX;
      startY = e.clientY;
      startLeft = dragTarget.offsetLeft;
      startTop = dragTarget.offsetTop;
      e.preventDefault();

      document.addEventListener('mousemove', onDrag);
      document.addEventListener('mouseup', stopDrag);
    });

    const onDrag = (e) => {
      if (!isDragging) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      dragTarget.style.left = `${startLeft + dx}px`;
      dragTarget.style.top = `${startTop + dy}px`;
    };

    const stopDrag = () => {
      isDragging = false;
      document.removeEventListener('mousemove', onDrag);
      document.removeEventListener('mouseup', stopDrag);
    };

    // --- Resize ---
    resizeHandle.addEventListener('mousedown', (e) => {
      isResizing = true;
      startX = e.clientX;
      startY = e.clientY;
      startWidth = dragTarget.offsetWidth;
      startHeight = dragTarget.offsetHeight;
      e.preventDefault();

      document.addEventListener('mousemove', onResize);
      document.addEventListener('mouseup', stopResize);
    });

    const onResize = (e) => {
      if (!isResizing) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      this.setState({
        width: Math.max(250, startWidth + dx),
        height: Math.max(150, startHeight + dy),
      });
    };

    const stopResize = () => {
      isResizing = false;
      document.removeEventListener('mousemove', onResize);
      document.removeEventListener('mouseup', stopResize);
    };
  }

  bringToFront() {
    document.getElementById('cmdApp').style.zIndex = 1;
    document.getElementById('streamPageApp').style.zIndex = 1;
    document.getElementById('storePageApp').style.zIndex = 1;
    document.getElementById('aboutPageApp').style.zIndex = 1;
    document.getElementById('contactPageApp').style.zIndex = 1;
    
    if (this.appRef.current) {
      this.appRef.current.style.zIndex = 2;
    }
  }

  closeApp() {
    if (this.appRef.current) {
      this.appRef.current.style.zIndex = 1;
      this.appRef.current.style.visibility = 'hidden';
    }
  }

  render() {
    const { width, height } = this.state;

    return (
      <div
        id={this.props.id}
        ref={this.appRef}
		    className="appWindow"
        onClick={this.bringToFront}
        style={{
          position: 'absolute',
          width: width,
          height: height,
          border: '2px solid white',
          backgroundColor: '#000',
          visibility: 'hidden',
        }}
      >
        {/* Standard top bar like About page */}
        <div id="cmdtitlearea" ref={this.titleRef}>
          <div className="closeButton" onClick={this.closeApp}>
            X
          </div>
        </div>

        {/* Clip content */}
        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
          {this.props.videoSrc.endsWith('.gif') ? (
            <img
              src={this.props.videoSrc}
              style={{ width: '100%', height: '100%' }}
              alt="clip"
            />
          ) : (
            <video
              src={this.props.videoSrc}
              autoPlay
              loop
              muted
              style={{ width: '100%', height: '100%' }}
              controls={false}
            />
          )}
        </div>

        {/* Resize handle */}
        <div
          className="resize-handle"
        />
      </div>
    );
  }
}

export default ClipWindow;
